<template>
  <div class="page">
    <router-view />
  </div>
</template>
<script>
import { defineComponent, onMounted } from "vue";

export default defineComponent({
  setup() {
    onMounted(() => {
      document.addEventListener("contextmenu", function(event) {
        event.preventDefault();
      });
    });
    return {};
  }
});
</script>
<style lang="scss">
body {
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  .page {
    height: 100vh;
  }
}
</style>
